import styled from "styled-components";


export const CheckboxWrapper = styled.div`
display: flex;
   label{
    display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  span{
    font-size: 12px;
     color: #001A16;
     font-weight: 600;
  }
   }
   &.assign{
      label{
         span{
         color: #00baf2;
         }
      }
   }
`;